// api/middlewares/index.ts
import { getEnv, navigate } from '@/common/agents';
import { ErrorCodes } from '$/api/errorCode';
import { message } from '$/components/Message';
import { redirectRemovedTeamMemberToPersonalHome } from '@/domains/team/redirectRemovedTeamMember';
import { isProjectAccessOverlayRoute } from '@/utils/projectAccessOverlayRoute';
import { Routes } from './errorCode';

/** AI Engine 返回成员已被移除错误时，清理团队态并返回个人首页。 */
function handleRemovedTeamMember(errorCode: unknown): boolean {
  return Number(errorCode) === ErrorCodes.TEAM_MEMBER_REMOVED
    && redirectRemovedTeamMemberToPersonalHome();
}

export const createErrorMiddleware = () => {
  return {
    onResponse: (response: any) => {
      const { error_code } = response?.data || {};
      if (handleRemovedTeamMember(error_code)) {
        return response;
      }
      const currentPath = window.location.pathname;

      switch (error_code) {
        case ErrorCodes.AUTH_EXPIRED:
          if (currentPath.includes(Routes.STUDIO)
            || currentPath.includes(Routes.PPT)
          || currentPath.includes(Routes.AI_FLOW)) {
            if (isShowErrorToast(response)) {
              message.error('RoboNeo_Web_login_status_fail');
            }
            navigate({
              mode: 'url',
              url: getEnv().ENV === 'development' ? '/--roboneo/home' : '/home',
              replace: true,
            });
            // navigate(Routes.HOME);
          }
          break;

        case ErrorCodes.ROOM_ACCESS_DENIED:
          if (!currentPath.includes(Routes.HOME) && !isProjectAccessOverlayRoute(currentPath)) {
            setTimeout(() => {
              navigate({
                mode: 'url',
                url: getEnv().ENV === 'development' ? '/--roboneo/home' : '/home',
                replace: true,
              });
            }, 3000);
          }
          break;

        case ErrorCodes.ROOM_DELETED:
          if (!currentPath.includes(Routes.NOT_FOUND)) {
            navigate({
              mode: 'url',
              url: getEnv().ENV === 'development' ? '/--roboneo/404' : '/404',
              replace: true,
            });
          }
          break;
      }

      return response;
    },
    onError: (error: any) => {
      const errorCode = error?.response?.data?.error_code ?? error?.data?.error_code;
      handleRemovedTeamMember(errorCode);
      return error?.response;
    },
  };
};

function isShowErrorToast(response: any) {
  const hideErrorToast = ['vipshow', 'roomcheck'];
  try {
    const { path_scene } = JSON.parse(response.config.data).parameter;
    return !hideErrorToast.includes(path_scene);
  } catch (error) {
    console.error('Error parsing response config:', error);
    return true;
  }
}
